import { apiClient } from '@api/client';
import type { Setting, SettingPayload, SettingUpdatePayload } from '@models/setting';

export async function getSettings(): Promise<Setting[]> {
  const { data } = await apiClient.get<Setting[]>('/settings');

  return data;
}

export async function getSetting(id: string): Promise<Setting> {
  const { data } = await apiClient.get<Setting>(`/settings/${id}`);

  return data;
}

export async function updateSetting(id: string, setting: SettingUpdatePayload): Promise<Setting> {
  const { data } = await apiClient.patch<Setting>(`/settings/${id}`, setting);

  return data;
}

export async function createSetting(setting: SettingPayload): Promise<Setting> {
  const { data } = await apiClient.post<Setting>('/settings', setting);

  return data;
}

export async function deleteSetting(id: string): Promise<void> {
  await apiClient.delete(`/settings/${id}`);
}
